export default __webpack_public_path__ + "static/media/005-suitcase.9f3583d8.png";